export default __webpack_public_path__ + "static/media/evelyn_chan.2801247e.jpg";